module.exports = __webpack_public_path__ + "img/zhinengjiaju2.f2f7a159.jpg";